import { Injectable } from '@angular/core'

import { BookableSlot } from './bookable-slot'
import * as bookableSlot from './bookable-slot.reducer'
import { Moment } from 'moment-mini'
@Injectable()
export class BookableSlotSerializer {
  fromJson(entity: any): BookableSlot {
    return {
      ...entity,
      id: bookableSlot.keyBy(entity),
      startDate: entity.startDate,
      endDate: entity.endDate
    }
  }

  toJson(bookableSlot: BookableSlot): any {
    return {
      ...bookableSlot,
      startDate: (bookableSlot.startDate as Moment).toISOString(),
      endDate: (bookableSlot.endDate as Moment).toISOString()
    }
  }
}
